<div class="content">
  <div class="description subtitle">
    {{ 'AUTOMATIONS.EDITOR.TASKS.APPROVE_SALES_ORDER.DESCRIPTION' | translate }}
  </div>
  <div class="alert-wrapper">
    <glxy-alert type="tip">
      <div
        [innerHtml]="'AUTOMATIONS.EDITOR.TASKS.APPROVE_SALES_ORDER.ACTION.DISCLAIMER' | translate | iTrustThisHtml"
      ></div>
    </glxy-alert>
  </div>
</div>
